//@flow

import React from "react"
import { FormattedMessage } from "react-intl"

import {
  ForecastMetricStatus,
  ForecastMetricStatusTitle,
  ForecastMetricStatusTrendContainer,
  ForecastMetricStatusTrend
} from "../UI"

import type { Level } from "../../Shared/AQILegend"
import type { Direction } from "../types"

const MetricStatus = ({
  level,
  direction
}: {
  level: Level,
  direction: Direction
}) => (
  <ForecastMetricStatus>
    <ForecastMetricStatusTitle>
      <FormattedMessage
        id={`kiosk.forecast.level.${level.replace(" ", "").toLowerCase()}`}
      />
    </ForecastMetricStatusTitle>
    {level === "No Data" ? (
      ""
    ) : (
      <ForecastMetricStatusTrendContainer>
        <ForecastMetricStatusTrend level={level} direction={direction}>
          <FormattedMessage id={`kiosk.forecast.direction.${direction}`} />
        </ForecastMetricStatusTrend>
      </ForecastMetricStatusTrendContainer>
    )}
  </ForecastMetricStatus>
)

export default MetricStatus



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/ForecastMetric/MetricStatus.js